import { Roles } from "../../constants/roles";
import { FormBase } from "../form-base-form";

class OgpPreviewForm extends FormBase {
    public getEventPreviewInput(event: Event): HTMLTextAreaElement | HTMLInputElement | null {
        return this.fromEventTarget(event, HTMLTextAreaElement) || this.fromEventTarget(event, HTMLInputElement);
    }

    public getRenderedPreview(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, "[data-ogp-url]", HTMLElement);
    }

    public getPreviewSection(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".ogp-preview-section", HTMLElement);
    }

    public getRootForm(root: Element | null | undefined): HTMLFormElement | null {
        return this.closest(root, "form", HTMLFormElement);
    }

    public getPostCreateForm(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, `[data-role="${Roles.POST_CREATE_FORM}"]`, HTMLElement);
    }

    public getContentImagesManager(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, ".content-images-manager", HTMLElement);
    }

    public getLimitWarning(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".ogp-limit-warning", HTMLElement);
    }

    public isInsideElementModal(root: Element | null | undefined): boolean {
        return (
            this.closest(
                root,
                `[data-role="${Roles.ELEMENT_MODAL_OVERLAY}"], [data-role="${Roles.ELEMENT_MODAL}"]`,
                HTMLElement,
            ) !== null
        );
    }

    public getCardContent(root: ParentNode): HTMLElement | null {
        return this.queryElement(
            root,
            `[data-role="${Roles.POST_CONTENT_DISPLAY}"], [data-role="${Roles.POST_DETAIL_CONTENT}"], .hidden`,
            HTMLElement,
        );
    }

    public getBoardMediaArea(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.BOARD_MEDIA_AREA}"], .media-area`, HTMLElement);
    }

    public getHrefLinks(root: ParentNode): HTMLAnchorElement[] {
        return this.queryElements(root, "a[href]", HTMLAnchorElement);
    }

    public getContentElementSnsAncestor(root: Element | null | undefined): HTMLElement | null {
        return this.closest(
            root,
            `[data-role="${Roles.SNS_EMBED}"], [data-role="${Roles.SNS_PREVIEW_TILE}"]`,
            HTMLElement,
        );
    }

    /**
     * A product-linker card embedded via the WYSIWYG toolbar (see
     * wysiwyg-product-embed/) contains several real <a href> links of its own
     * (product/brand/category); DOM-based OGP scanning must skip them the same
     * way it already skips SNS embeds, or the card's own links get mistaken
     * for a user-pasted link worth an OGP preview.
     */
    public getContentElementProductEmbedAncestor(root: Element | null | undefined): HTMLElement | null {
        return this.closest(root, ".ql-product-embed", HTMLElement);
    }

    public getProductEmbedElements(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".ql-product-embed", HTMLElement);
    }
}

const ogpPreviewForm = new OgpPreviewForm();

export { OgpPreviewForm, ogpPreviewForm };
